<template>
  <v-app>
    <div v-if="nav">
      <v-navigation-drawer
        mobile-breakpoint="1150"
        v-model="side_bar"
        app
        width="250"
      >
        <template v-slot:prepend>
          <v-row class="mt-n1 mb-n3" justify="center">
            <v-col>
              <v-avatar class="px-5" tile width="227" height="48">
                <v-img contain src="./assets/Group.png" />
              </v-avatar>
            </v-col>
          </v-row>
        </template>

        <v-divider></v-divider>

        <v-container fluid>
          <v-row align="center">
            <v-col cols="12" md="12">
              <v-card flat class="mx-auto" max-width="100%">
                <v-list-item-group v-if="menu_interno()">
                  <v-list rounded dense class="mt-6">
                    <div v-for="(item, index) in meu_titulo" :key="index">
                      <router-link :to="item.modulo_url" v-if="acesso(item)">
                        <v-list-item
                          class="mt-3 black--text"
                          :class="{
                            'blue lighten-4 black--text':
                              $router.currentRoute.path == item.modulo_url,
                          }"
                        >
                          <v-list-item-icon>
                            <v-icon>{{ item.modulo_icone }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.modulo_nome }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </router-link>
                    </div>
                  </v-list>
                </v-list-item-group>

                <v-list-item-group v-else>
                  <v-list rounded dense class="mt-8">
                    <div v-for="(item, index) in modulos" :key="index">
                      <router-link
                        :to="item.modulo_url"
                        v-if="item.modulo_config == 0 && item.id_modulo != 18"
                      >
                        <v-list-item
                          class="mt-3 black--text"
                          :class="{
                            'blue lighten-4 black--text':
                              $router.currentRoute.path == item.modulo_url,
                          }"
                        >
                          <v-list-item-icon>
                            <v-icon>{{ item.modulo_icone }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.modulo_nome }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </router-link>
                    </div>

                    <v-list-group
                      sub-group
                      :value="verifConfigPath()"
                      class="mt-3 padding_menu ml-n2"
                      prepend-icon="mdi-cog"
                      v-if="verifConfig(modulos)"
                    >
                      <template v-slot:activator>
                        <v-list-item-title class="ml-3 mr-1"
                          >Configurações</v-list-item-title
                        >
                      </template>

                      <div v-for="(item, index) in modulos" :key="index">
                        <router-link
                          :to="item.modulo_url"
                          v-if="item.modulo_config == 1"
                        >
                          <v-list-item
                            class="mt-3 black--text"
                            :class="{
                              'blue lighten-4 black--text':
                                $router.currentRoute.path == item.modulo_url,
                            }"
                          >
                            <v-list-item-icon>
                              <v-icon>{{ item.modulo_icone }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ item.modulo_nome }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </router-link>
                      </div>
                    </v-list-group>
                  </v-list>
                </v-list-item-group>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <template v-slot:append>
          <v-divider></v-divider>
          <v-container>
            <v-row justify="center">
              <v-subheader>
                <a :href="link_termos" target="_blank" v-if="link_termos"
                  >Termos de Uso</a
                >
              </v-subheader>
            </v-row>
          </v-container>
        </template>
      </v-navigation-drawer>
      <v-app-bar app dense class="white" elevation="1" height="55">
        <v-icon @click="side_bar = !side_bar" class="d-flex d-lg-none mr-2"
          >mdi-menu</v-icon
        >
        <v-divider class="d-flex d-lg-none mx-2" vertical></v-divider>
        <!-- <v-icon class="d-none d-md-flex">mdi-magnify</v-icon> -->
        <!-- <v-col md="5" sm="5" cols="4">
          <v-text-field hide-details clearable solo disabled flat placeholder="Buscar" single-line></v-text-field>
        </v-col>-->
        <v-spacer></v-spacer>
        <a
          v-if="diasRestantes >= 0 && diasRestantes <= 5"
          target="_blank"
          :href="this.linkAsaas"
          ><span
            class="mr-3 red--text font-weight-bold text-decoration-underline"
          >
            Dias para pagar plano do clube: {{ diasRestantes }}
          </span></a
        ><v-btn
          @click="dialog_clubes = true"
          class="d-block white--text"
          rounded
          x-medium
          color="#283480"
          style="text-transform: capitalize"
          max-width="100%"
          v-if="clubeAtual"
          :title="clubeAtual.clube_nome_comercial"
        >
          <v-avatar size="30" class="white" v-if="clubeAtual.clube_logotipo">
            <v-img
              height="30"
              contain
              :src="clubeAtual.clube_logotipo"
              :lazy-src="clubeAtual.clube_logotipo"
            />
          </v-avatar>
          <v-avatar size="30" color="#283480" v-if="!clubeAtual.clube_logotipo">
            <span class="white--text headline text-uppercase">
              {{ clubeAtual.clube_nome_comercial.charAt(0) }}
            </span>
          </v-avatar>
          <span class="ml-1 text-truncate">
            {{ clubeAtual.clube_nome_comercial }}
          </span>
        </v-btn>
        <v-btn text rounded @click="logout()">
          <span>Sair</span>
          <v-icon>mdi-login</v-icon>
        </v-btn>

        <!-- <v-badge color="#FF1313" overlap dot>
          <v-btn small icon>
            <v-icon>mdi-bell</v-icon>
          </v-btn>
        </v-badge>-->

        <!-- DIALOG CLUBES -->
        <v-dialog v-model="dialog_clubes" persistent max-width="750">
          <v-card class="borda" flat>
            <v-card-title>
              <div class="ml-1">
                <span class="headline">Clubes disponíveis</span>
              </div>
              <span class="headline ma-3"></span>
              <v-spacer></v-spacer>
              <v-btn icon text @click="dialog_clubes = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-2">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                :autofocus="true"
                class="mb-3"
              ></v-text-field>
              <v-container>
                <v-row dense>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(item, index) in filteredClubes"
                      :key="index"
                      :readonly="!item.distritos && !item.clubes"
                    >
                      <v-expansion-panel-header>
                        <v-row style="flex: 0 1 auto" class="mr-2">
                          <v-avatar size="32" v-if="item.clube_logotipo">
                            <img
                              :src="item.clube_logotipo"
                              :lazy-src="item.clube_logotipo"
                            />
                          </v-avatar>
                          <v-avatar
                            size="32"
                            color="#283480"
                            v-if="!item.clube_logotipo"
                          >
                            <span class="white--text headline text-uppercase">
                              {{ item.clube_nome_comercial.charAt(0) }}
                            </span>
                          </v-avatar>
                        </v-row>
                        <span style="flex: 0 1 auto">
                          {{ item.clube_nome_comercial }}
                        </span>
                        <v-row style="flex: 0 1 auto">
                          <v-btn
                            @click="
                              (dialog_alterar = true), (clubeChange = item)
                            "
                            class="ma-2 ml-5"
                            rounded
                            disabled
                            x-small
                            outlined
                            color="primary"
                          >
                            <span v-if="item.clube_hierarquia == 1">Clube</span>
                            <span v-if="item.clube_hierarquia == 2"
                              >Distrito</span
                            >
                            <span v-if="item.clube_hierarquia == 3"
                              >Distrito Múltiplo</span
                            >
                          </v-btn>
                        </v-row>
                        <v-row style="flex: 0 1 auto">
                          <v-btn
                            @click="
                              (dialog_alterar = true), (clubeChange = item)
                            "
                            class="ma-2 ml-5"
                            rounded
                            x-small
                            outlined
                            color="primary"
                            :disabled="
                              item.clube_token == clubeAtual.clube_token
                            "
                            >Acessar</v-btn
                          >
                        </v-row>
                        <template v-slot:actions>
                          <v-icon v-if="item.distritos || item.clubes"
                            >$expand</v-icon
                          >
                          <v-icon
                            v-if="!item.distritos && !item.clubes"
                          ></v-icon>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <!-- ACCORDIONS INTERNOS -->
                        <v-expansion-panels>
                          <v-expansion-panel
                            v-for="(item2, index) in item.distritos"
                            :key="index"
                            :readonly="!item2.clubes.length"
                          >
                            <v-expansion-panel-header>
                              <v-row style="flex: 0 1 auto" class="mr-2">
                                <v-avatar size="32" v-if="item2.clube_logotipo">
                                  <img
                                    :src="item2.clube_logotipo"
                                    :lazy-src="item2.clube_logotipo"
                                  />
                                </v-avatar>
                                <v-avatar
                                  size="32"
                                  color="#283480"
                                  v-if="!item2.clube_logotipo"
                                >
                                  <span
                                    class="white--text headline text-uppercase"
                                  >
                                    {{ item2.clube_nome_comercial.charAt(0) }}
                                  </span>
                                </v-avatar>
                              </v-row>
                              <span style="flex: 0 1 auto">
                                {{ item2.clube_nome_comercial }}
                              </span>
                              <v-row style="flex: 0 1 auto">
                                <v-btn
                                  @click="
                                    (dialog_alterar = true),
                                      (clubeChange = item)
                                  "
                                  class="ma-2 ml-5"
                                  rounded
                                  disabled
                                  x-small
                                  outlined
                                  color="primary"
                                >
                                  <span v-if="item2.clube_hierarquia == 1"
                                    >Clube</span
                                  >
                                  <span v-if="item2.clube_hierarquia == 2"
                                    >Distrito</span
                                  >
                                  <span v-if="item2.clube_hierarquia == 3"
                                    >Distrito Múltiplo</span
                                  >
                                </v-btn>
                              </v-row>
                              <v-row style="flex: 0 1 auto">
                                <v-btn
                                  @click="
                                    (dialog_alterar = true),
                                      (clubeChange = item2)
                                  "
                                  class="ma-2 ml-5"
                                  rounded
                                  x-small
                                  outlined
                                  color="primary"
                                  :disabled="
                                    item2.clube_token == clubeAtual.clube_token
                                  "
                                  >Acessar</v-btn
                                >
                              </v-row>
                              <template v-slot:actions>
                                <v-icon v-if="item2.clubes.length"
                                  >$expand</v-icon
                                >
                                <v-icon v-if="!item2.clubes.length"></v-icon>
                              </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <!-- ACCORDIONS INTERNOS -->
                              <v-expansion-panels>
                                <v-expansion-panel
                                  v-for="(item3, index) in item2.clubes"
                                  :key="index"
                                  :readonly="true"
                                >
                                  <v-expansion-panel-header>
                                    <v-row style="flex: 0 1 auto" class="mr-2">
                                      <v-avatar
                                        size="32"
                                        v-if="item3.clube_logotipo"
                                      >
                                        <img
                                          :src="item3.clube_logotipo"
                                          :lazy-src="item3.clube_logotipo"
                                        />
                                      </v-avatar>
                                      <v-avatar
                                        size="32"
                                        color="#283480"
                                        v-if="!item3.clube_logotipo"
                                      >
                                        <span
                                          class="
                                            white--text
                                            headline
                                            text-uppercase
                                          "
                                        >
                                          {{
                                            item3.clube_nome_comercial.charAt(0)
                                          }}
                                        </span>
                                      </v-avatar>
                                    </v-row>
                                    <span style="flex: 0 1 auto">
                                      {{ item3.clube_nome_comercial }}
                                    </span>
                                    <v-row style="flex: 0 1 auto">
                                      <v-btn
                                        @click="
                                          (dialog_alterar = true),
                                            (clubeChange = item)
                                        "
                                        class="ma-2 ml-5"
                                        rounded
                                        disabled
                                        x-small
                                        outlined
                                        color="primary"
                                      >
                                        <span v-if="item3.clube_hierarquia == 1"
                                          >Clube</span
                                        >
                                        <span v-if="item3.clube_hierarquia == 2"
                                          >Distrito</span
                                        >
                                        <span v-if="item3.clube_hierarquia == 3"
                                          >Distrito Múltiplo</span
                                        >
                                      </v-btn>
                                    </v-row>
                                    <v-row style="flex: 0 1 auto">
                                      <v-btn
                                        @click="
                                          (dialog_alterar = true),
                                            (clubeChange = item3)
                                        "
                                        class="ma-2 ml-5"
                                        rounded
                                        x-small
                                        outlined
                                        color="primary"
                                        :disabled="
                                          item3.clube_token ==
                                          clubeAtual.clube_token
                                        "
                                        >Acessar</v-btn
                                      >
                                    </v-row>
                                    <template v-slot:actions>
                                      <v-icon></v-icon>
                                    </template>
                                  </v-expansion-panel-header>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- DIALOG ALTERAR CLUBE -->
        <v-dialog v-model="dialog_alterar" persistent max-width="450">
          <v-card class="borda" flat>
            <v-card-title class="headline"
              >Deseja realmente trocar de conta?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outlined rounded color="#283480" @click="close()"
                >Cancelar</v-btn
              >
              <v-btn
                style="
                  background-color: #283480 !important;
                  color: #00ffd4 !important;
                "
                rounded
                :loading="loadingAlterar"
                :disabled="loadingAlterar"
                @click="trocarClube()"
                >Sim</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-app-bar>
    </div>

    <v-main>
      <v-container class="back" fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";

export default {
  data() {
    return {
      meu_titulo: [
        {
          modulo_nome: "Acessar Clube",
          modulo_icone: "mdi-arrow-left",
          modulo_url: "/dashboard",
        },
        {
          modulo_nome: "Meu Título",
          modulo_icone: "mdi-account-star",
          modulo_url: "/meu_titulo",
        },
        {
          modulo_nome: "Documentos",
          modulo_icone: "mdi-file-document",
          modulo_url: "/meus_documentos",
        },
        {
          modulo_nome: "Mensagens",
          modulo_icone: "mdi-email-outline",
          modulo_url: "/minhas_mensagens",
        },
        {
          modulo_nome: "Eventos",
          modulo_icone: "mdi-calendar",
          modulo_url: "/meus_eventos",
        },
        {
          modulo_nome: "Meus Reembolsos",
          modulo_icone: "mdi-cash-usd-outline",
          modulo_url: "/meus_reembolsos",
        },
      ],
      nav: false,
      notification: false,
      item_group: null,
      item_group2: null,
      side_bar: null,
      template: 0,
      clubeInicial: "",
      clube: "",
      clubes: [],
      clubeAtual: "",
      clubeChange: "",
      search: "",
      modulos: [],
      diasRestantes: -1,
      dialog_alterar: false,
      loadingAlterar: false,
      dialog_clubes: false,
      link_termos: "",
      participantes: {
        id_modulo: 18,
        modulo_config: 0,
        modulo_em_breve: 0,
        modulo_icone: "mdi-account",
        modulo_nome: "Participantes",
        modulo_ordem: 25,
        modulo_url: "/meus_eventos",
      },
    };
  },

  created() {
    //this.getClubes();
    this.getConfigs();
  },
  computed: {
    filteredClubes() {
      return this.clubes.filter((item) => {
        return item.clube_nome_comercial
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });

      /*let search = this.search;
      return this.clubes.filter(function(clube) {
        let categoria = categ.tipos.find(function(tipo) {
          //return tipo.id_tipo_lancamento === tipoSelecionado;
          return item.clube_nome_comercial.toLowerCase().includes(search.toLowerCase())
        });
        return categoria;
      });*/
    },
  },

  watch: {
    $route() {
      let name = this.$router.currentRoute.name;
      if (
        name === "Login" ||
        name === "Home" ||
        name === "construcao" ||
        name === "NovoPlano" ||
        name === "FirstLogin" ||
        name === "Compras" ||
        name === "RecuperarSenha"
      ) {
        this.nav = false;
      } else {
        this.nav = true;
        this.getClubes();
        this.diasRestante();
      }
    },
  },

  methods: {
    diasRestante() {
      let user = localStorage.getItem("user-token");
      Api.get(`/daysToOverdue`)
        .then((response) => {
          if (response.data.error) {
            this.$toast.warning("Clube está com o pagamento atrasado.");
            setTimeout(() => {
              this.logout();
            }, 3000);
          } else if (response.data.diasRestantes) {
            let tokens = response.data.diasRestantes.token;
            for (let i = 0; i < tokens.length; i++) {
              if (tokens[i].token == user) {
                this.linkAsaas = response.data.diasRestantes.link;
                this.diasRestantes = response.data.diasRestantes.dias;
                // this.$toast.warning(
                //   "Dias Restantes paga realizar pagamento: " + response.data.diasRestantes.dias
                // );
              }
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    acesso(item) {
      if (item.modulo_nome == "Acessar Clube") {
        if (this.modulos.length > 0) {
          if (this.modulos[0].id_modulo == 1) {
            return true;
          } else {
            this.modulos.shift();
            return false;
          }
        }
      } else {
        return true;
      }
    },

    logout() {
      let slug = JSON.parse(localStorage.getItem("clube-atual")).clube_slug;
      localStorage.removeItem("token");
      localStorage.removeItem("user-token");
      localStorage.removeItem("clubes");
      localStorage.removeItem("clube-atual");
      this.$router.push({ name: "Login", params: { clubeSlug: slug } });
    },
    getClubes() {
      if (localStorage.getItem("token")) {
        this.clubeInicial = localStorage.getItem("token");
        this.clube = localStorage.getItem("token");
      }
      if (localStorage.getItem("clube-atual")) {
        this.clubeAtual = JSON.parse(localStorage.getItem("clube-atual"));
        this.modulos = this.clubeAtual.modulos;
      }
      if (localStorage.getItem("clubes")) {
        this.clubes = JSON.parse(localStorage.getItem("clubes"));
      }
    },
    menu_interno() {
      if (
        this.$router.currentRoute.path == "/meus_documentos" ||
        this.$router.currentRoute.path.substr(0, 13) == "/meus_eventos" ||
        this.$router.currentRoute.path == "/meu_titulo" ||
        this.$router.currentRoute.path == "/minhas_mensagens" ||
        this.$router.currentRoute.path == "/meus_reembolsos"
      ) {
        return true;
      } else {
        return false;
      }
    },
    close() {
      this.dialog_alterar = false;
      this.clube = this.clubeInicial;
    },

    trocarClube() {
      this.loadingAlterar = true;
      this.clubeInicial = this.clubeChange.clube_token;
      localStorage.setItem("token", this.clubeChange.clube_token);
      localStorage.setItem("clube-atual", JSON.stringify(this.clubeChange));
      this.clubeChange = "";
      location.reload();
    },

    getConfigs() {
      Api.get(`/get-configs`)
        .then((response) => {
          if (response.data) {
            this.link_termos = response.data.config_link_termos;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    verifConfigPath() {
      for (var i = 0; i < this.modulos.length; i++) {
        if (this.modulos[i].modulo_config) {
          if (this.modulos[i].modulo_url == this.$router.currentRoute.path) {
            return true;
          }
        }
      }
      return false;
    },
    verifConfig() {
      for (var i = 0; i < this.modulos.length; i++) {
        if (this.modulos[i].modulo_config) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style>
.azul {
  color: #283480;
}
.ativado {
  color: #1f36c7 !important;
  background-color: #f5f9fc !important;
}
.ativado2 {
  /* blue lighten-4 black--text */
  background-color: #1f36c7 !important;
  color: rgb(165, 196, 222) !important;
}
.agua {
  color: #00ffd4 !important;
}
.azul {
  color: #1f36c7 !important;
}
.borda {
  border-collapse: collapse !important;
  border-radius: 1em !important;
  overflow: hidden !important;
}
.verdi {
  background-color: #00ffd429 !important;
  border-radius: 50% !important;
  padding: 2px !important;
}
.vermelho {
  background-color: #ff141421 !important;
  border-radius: 50% !important;
  padding: 2px !important;
}
.vermelho2 {
  color: #ff1414b0 !important;
}
.verde2 {
  color: #00bba5 !important;
}
.amarelo {
  background-color: #ffde1438 !important;
  border-radius: 50% !important;
}
.titulo {
  color: #28374e !important;
}
.back {
  background-color: #f5f9fc !important;
}
.barra_r {
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
  border-bottom-style: solid !important;
  border-bottom-color: #ff1414b0 !important;
  border-bottom-width: 7px !important;
}
.barra_g {
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
  border-bottom-style: solid !important;
  border-bottom-color: #00dbc1 !important;
  border-bottom-width: 7px !important;
}
.barra_b {
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
  border-bottom-style: solid !important;
  border-bottom-color: #2638ad !important;
  border-bottom-width: 7px !important;
}
.timeline {
  margin-left: 4%;
  padding-left: 5%;
  border-left-style: solid !important;
  border-left-color: #c4c4c4 !important;
  border-left-width: 1px !important;
}
@media (max-width: 1150px) {
  .fluxo {
    padding-left: 12px !important;
    padding-right: 12px !important;
    margin-top: 4px !important;
  }
  .dash {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
  .doc {
    margin-left: 3px !important;
    margin-right: 3px !important;
  }
}
@media (min-width: 1150px) {
  .fluxo {
    padding-left: 36px !important;
    padding-right: 36px !important;
    margin-top: 20px !important;
  }
  .dash {
    padding-left: 48px !important;
    padding-right: 48px !important;
  }
  .doc {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
}
button.v-btn[disabled] {
  opacity: 0.8 !important;
}
* {
  text-decoration: none;
  /* font-family: "Ubuntu", sans-serif !important; */
}

.input {
  border-collapse: collapse;
  border-color: currentColor;
  border-style: solid;
  border-width: 1px;
  transition-duration: 0.3s;
  transition-property: color, border-width;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);

  min-height: 40px;
  padding: 0 12px;
  background: #ffffff;
  margin-bottom: 4px;
  cursor: text;
  width: 100%;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex: 1 1 auto;
  font-size: 16px;
  letter-spacing: normal;
  max-width: 100%;
  text-align: left;
  border-color: rgba(0, 0, 0, 0.42);
}

.toast-text {
  font-family: "Roboto", sans-serif;
}

.v-select__selections {
  line-height: normal !important;
}
.inativo_conta {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  font-weight: 400;
  padding-left: 10px;
}

.table_interna_lancamentos * {
  overflow: hidden !important;
}
</style>